import base from "D:/Adi/Personal/Project/monochrome/images/genius-active.svg?svg";
import { getResizer } from "svg-merge-attributes";
export default getResizer(base, "");